(function(){
  const banner = document.querySelector("[id^='appBanner-']");
  
  if(!banner) return;

  const delay = parseInt(banner.dataset.delay, 10) * 1000 || 0;
  const frequency = parseInt(banner.dataset.frequency, 10) || 7; // days
  const storageKey = "appBannerDismissed-" + banner.id.replace("appBanner-", "");

  const getStored = () => {
    try { return JSON.parse(localStorage.getItem(storageKey)); }
    catch(e){ return null; }
  };

  const setStored = (days) => {
    const expires = Date.now() + (days * 864e5);
    localStorage.setItem(storageKey, JSON.stringify({ expires }));
  };

  const shouldShow = () => {
    const data = getStored();
    if(!data) return true;
    return Date.now() > data.expires;
  };

  const adjustMobileMenu = (offset) => {
    if (!document.body.classList.contains("mobilemenu--isVisible")) return;

    const mobileMenu = document.getElementById("mobilemenu");
    if (!mobileMenu) return;

    const currentTop =
      parseInt(window.getComputedStyle(mobileMenu).top, 10) || 0;

    mobileMenu.style.top = `${currentTop + offset}px`;
  };

  const showBanner = () => {
    banner.style.display = "block";
    adjustMobileMenu(80);
  };

  const dismissBanner = () => {
    banner.style.display = "none";
    setStored(frequency);
    adjustMobileMenu(-80);
  };

  // Delay before showing
  if(shouldShow()){
    setTimeout(showBanner, delay);
  }

  // Close button
  const closeBtn = banner.querySelector(".app-banner__close"); 
  if(closeBtn){
    closeBtn.addEventListener("click", dismissBanner);
  }

  // CTA button
  const ctaBtn = banner.querySelector(".app-banner__cta a");
  if(ctaBtn){
    ctaBtn.addEventListener("click", dismissBanner);
  }
})();
